import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]        = useState('');
  const [loading, setLoading]    = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(username.trim(), password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f6fa',
    }}>
      <div style={{
        width: 400,
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(0,0,0,0.09)',
        padding: '48px 40px',
      }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ overflow: 'hidden', height: 54, display: 'inline-block' }}>
            <img
              src="/travelscape-logo.png"
              alt="Travelscape"
              style={{ width: 220, display: 'block', marginTop: -4 }}
            />
          </div>
          <div style={{ fontSize: 11, fontWeight: 500, color: '#9ca3af', letterSpacing: '0.5px', marginTop: 2 }}>
            TravelAcc Pro
          </div>
          <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 16 }}>Sign in to your account</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Username</label>
              <input
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="e.g. admin"
                required
                style={{
                  width: '100%', padding: '10px 14px',
                  border: '1px solid #d1d5db', borderRadius: 8,
                  fontSize: 14, color: '#1a1d27', outline: 'none',
                  background: '#fff', transition: 'border-color 0.15s',
                }}
                onFocus={e => e.target.style.borderColor = '#f07040'}
                onBlur={e  => e.target.style.borderColor = '#d1d5db'}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                  width: '100%', padding: '10px 14px',
                  border: '1px solid #d1d5db', borderRadius: 8,
                  fontSize: 14, color: '#1a1d27', outline: 'none',
                  background: '#fff', transition: 'border-color 0.15s',
                }}
                onFocus={e => e.target.style.borderColor = '#f07040'}
                onBlur={e  => e.target.style.borderColor = '#d1d5db'}
              />
            </div>

            {error && (
              <div style={{
                background: '#fef2f2', border: '1px solid #fecaca',
                borderRadius: 8, padding: '10px 14px',
                color: '#dc2626', fontSize: 13,
              }}>{error}</div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: 4,
                width: '100%', padding: '12px',
                background: loading ? '#f5a882' : '#f07040',
                color: '#fff', border: 'none', borderRadius: 8,
                fontSize: 15, fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => { if (!loading) e.target.style.background = '#d95e2e'; }}
              onMouseLeave={e => { if (!loading) e.target.style.background = '#f07040'; }}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
